import { AppSeo } from "@/components/AppSeo";
import { NotesPanel } from "@/components/notes/NotesPanel";
import { useWorkspace } from "@/hooks/useWorkspace";

const Notes = () => {
  const { active } = useWorkspace();

  return (
    <>
      <AppSeo title="Notes" />
      <div className="flex h-full min-h-0 flex-col gap-3">
        <div className="flex shrink-0 items-end justify-between gap-3">
          <div className="min-w-0">
            <h1 className="font-serif text-2xl font-semibold sm:text-3xl">Notes</h1>
            <p className="hidden text-sm text-muted-foreground sm:block">
              Quick, plain-text capture. Organize into folders when you're ready.
            </p>
          </div>
        </div>
        <div className="min-h-0 flex-1">
          {active ? (
            <NotesPanel workspaceId={active.id} />
          ) : (
            <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
              Loading workspace…
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Notes;
